/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderTypeAdditionServiceRespVo } from './OrderTypeAdditionServiceRespVo';
import {
    OrderTypeAdditionServiceRespVoFromJSON,
    OrderTypeAdditionServiceRespVoFromJSONTyped,
    OrderTypeAdditionServiceRespVoToJSON,
    OrderTypeAdditionServiceRespVoToJSONTyped,
} from './OrderTypeAdditionServiceRespVo';

/**
 * 
 * @export
 * @interface ResponseOrderTypeAdditionServiceRespVo
 */
export interface ResponseOrderTypeAdditionServiceRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseOrderTypeAdditionServiceRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseOrderTypeAdditionServiceRespVo
     */
    message?: string;
    /**
     * 
     * @type {OrderTypeAdditionServiceRespVo}
     * @memberof ResponseOrderTypeAdditionServiceRespVo
     */
    data?: OrderTypeAdditionServiceRespVo;
}

/**
 * Check if a given object implements the ResponseOrderTypeAdditionServiceRespVo interface.
 */
export function instanceOfResponseOrderTypeAdditionServiceRespVo(value: object): value is ResponseOrderTypeAdditionServiceRespVo {
    return true;
}

export function ResponseOrderTypeAdditionServiceRespVoFromJSON(json: any): ResponseOrderTypeAdditionServiceRespVo {
    return ResponseOrderTypeAdditionServiceRespVoFromJSONTyped(json, false);
}

export function ResponseOrderTypeAdditionServiceRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOrderTypeAdditionServiceRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OrderTypeAdditionServiceRespVoFromJSON(json['data']),
    };
}

export function ResponseOrderTypeAdditionServiceRespVoToJSON(json: any): ResponseOrderTypeAdditionServiceRespVo {
    return ResponseOrderTypeAdditionServiceRespVoToJSONTyped(json, false);
}

export function ResponseOrderTypeAdditionServiceRespVoToJSONTyped(value?: ResponseOrderTypeAdditionServiceRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': OrderTypeAdditionServiceRespVoToJSON(value['data']),
    };
}

